import { FETCH_BRAND, FETCH_BRAND_DATA_LOADING, FETCH_BRAND_ERROR, SET_BRAND } from "@/store/constants/brand";
import BrandService from "@/services/api/brand.service";
import AppConfig from "@/config/app-config";

const state = {
  error: false,
  loading: false,
  brand: {},
  lightLogoUrl: "",
  darkLogoUrl: "",
  basicIconUrl: "",
  appleTouchIconUrl: "",
  pwaSmallIconUrl: "",
  pwaLargeIconUrl: "",
  theme: AppConfig.styles,
};

const mutations = {
  [FETCH_BRAND_DATA_LOADING]: (state, loading) => {
    state.loading = loading;
  },
  [SET_BRAND]: (state, data) => {
    state.lightLogoUrl = data.lightLogoUrl;
    state.darkLogoUrl = data.darkLogoUrl;
    state.basicIconUrl = data.basicIconUrl;
    state.appleTouchIconUrl = data.appleTouchIconUrl;
    state.pwaSmallIconUrl = data.pwaSmallIconUrl;
    state.pwaLargeIconUrl = data.pwaLargeIconUrl;
    state.brand = AppConfig.brands[data.brand];

    AppConfig.loadedBrand = state.brand
    AppConfig.showInfoSections = AppConfig.loadedBrand === AppConfig.brands.FINRAX_LT;
    if (
      AppConfig.loadedBrand === AppConfig.brands.B2BPAY ||
      AppConfig.loadedBrand === AppConfig.brands.VIRAPAY ||
      AppConfig.loadedBrand === AppConfig.brands.MALDO ||
      AppConfig.loadedBrand === AppConfig.brands.AXOM ||
      AppConfig.loadedBrand === AppConfig.brands.DIGIBLOX
    ) {
      state.theme.primaryColor = "#1567A6";
      state.theme.sidebarHeaders = "#7BC2FF";
      state.theme.positiveButtonAction = "#509DE4";
      state.theme.userRole = "#7BC2FF";
    }

    AppConfig.setTheme(state.theme);
    AppConfig.setDocumentTitle();
    AppConfig.setFavicon(state.basicIconUrl);
  },
  [FETCH_BRAND_ERROR]: (state, error) => {
    state.error = error;
  },
};

const actions = {
  async [FETCH_BRAND]({ commit }) {
    commit(FETCH_BRAND_ERROR, false);
    commit(FETCH_BRAND_DATA_LOADING, true);
    try {
      const data = await BrandService.fetchBrand();
      commit(SET_BRAND, data);
    } catch (e) {
      commit(FETCH_BRAND_ERROR, true);
    } finally {
      commit(FETCH_BRAND_DATA_LOADING, false);
    }
  },
};
export default {
  state,
  actions,
  mutations,
};
